import React from 'react';

export const UpdateProgramDetailsActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} {props.GetPhrase()} the {props.CustomEventData ? props.CustomEventData.fieldName : ""}.
</p>;


